// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_d10fcaf","container":"_afef1c3","title":"_a61c654","gamesInnerContainer":"_dde035c"};